import React, { useEffect, useRef, useState } from 'react';
import classes from './select.module.scss';
import cn from 'classnames';
import { ReactComponent as ChevronIcon } from '../../img/chevron-down.svg';
import { ReactComponent as CheckIcon } from '../../img/check.svg';
import { isMobile } from 'react-device-detect';

interface SelectProps {
  selected: string;
  disabled?: boolean;
  error?: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  label?: string;
  children?: React.ReactNode;
}

interface SelectOption {
  value: string;
  label: string;
}

const Select = ({
  selected,
  disabled,
  error,
  options,
  onChange,
  label,
  children,
}: SelectProps) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const [menuHeight, setMenuHeight] = useState(50);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      menuRef.current && setMenuHeight(menuRef.current.scrollHeight);
    } else {
      setMenuHeight(50);
    }
  }, [isOpen]);

  const handleOpen = (open: boolean) => {
    !disabled && setIsOpen(open);
  }

  return (
    <div className={classes.selectWrapper}>
      {label &&
        <span className={classes.selectWrapper__label}>
          {label}
        </span>
      }
      <div
        className={classes.select}
        onMouseEnter={isMobile ? undefined : () => handleOpen(true)}
        onMouseLeave={isMobile ? undefined : () => handleOpen(false)}
        onFocus={isMobile ? undefined : () => handleOpen(true)}
        onBlur={() => handleOpen(false)}
        tabIndex={0}
      >
        <div
          className={cn(classes.select__input, {
            [classes.select__input_disabled]: disabled,
            [classes.select__input_error]: error,
          })}
        >
          {error || options.find(option => option.value === selected)?.label || 'Устройство по умолчанию'}
        </div>
        <div
          className={cn(classes.select__trigger, {
            [classes.select__trigger_opened]: isOpen,
          })}
          onClick={() => handleOpen(!isOpen)}
          title={options.find(option => option.value === selected)?.label}
        />
        <div
          ref={menuRef}
          style={{ height: menuHeight }}
          className={cn(classes.select__menu, classes.menu, {
            [classes.menu_opened]: isOpen,
          })}
        >
          {!disabled && <ChevronIcon
            className={cn(classes.menu__icon, {
              [classes.menu__icon_opened]: isOpen,
            })}
          />}
          {!disabled && <div className={classes.menu__content}>
            <div className={classes.menu__divider}/>
            {options.map((option) => (
              <div
                key={option.value}
                className={cn(classes.menu__item, {
                  [classes.menu__item_selected]: option.value === selected,
                })}
                title={option.label}
                onClick={() => onChange(option.value)}
              >
                {option.label}
                {option.value === selected && <CheckIcon className={classes.menu__item__icon}/>}
              </div>
            ))}
            {isOpen && children}
          </div>}
        </div>
      </div>
    </div>
  );
}

export default Select;